import { EventStatus } from "@ticketingplatform/api/dist/__generated__/globalTypes";
import { Button, Divider, Form, Space } from "antd";
import { FC } from "react";
import { FormattedMessage } from "react-intl";
import MainCreationForm from "components/forms/MainCreationForm";
import Tabs from "components/layout/Tabs";

import { useRecuringEventFormSubmitButtons, useEventFormTabs } from "./hooks";
import { EventTemplateFormProps } from "./types";

const RecuringEventForm: FC<EventTemplateFormProps> = ({
  eventType,
  disabled,
  form,
  loading,
  eventStatus = EventStatus.DRAFT,
  isRecurringEventCreate,
  isRecurringEventDetails,
  templateId,
  ...props
}) => {
  const { onDraft, onPublish } = useRecuringEventFormSubmitButtons(form);
  const items = useEventFormTabs(
    eventType,
    isRecurringEventCreate,
    isRecurringEventDetails,
    templateId
  );

  return (
    <MainCreationForm
      layout="vertical"
      disabled={disabled || loading}
      {...{ form, ...props }}
    >
      {(_, __, { isSubmitting }) => (
        <>
          <Tabs {...{ items }} />
          <Divider />
          <Space>
            {eventStatus === EventStatus.DRAFT ? (
              <>
                <Form.Item name={["input", "status"]}>
                  <Button
                    type="default"
                    htmlType="submit"
                    onClick={onDraft}
                    size="large"
                    loading={isSubmitting}
                    {...{ disabled }}
                  >
                    <FormattedMessage defaultMessage="Save as a draft" />
                  </Button>
                </Form.Item>
                <Form.Item name={["input", "status"]}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    onClick={onPublish}
                    size="large"
                    loading={isSubmitting}
                    {...{ disabled }}
                  >
                    <FormattedMessage defaultMessage="Publish recurring event" />
                  </Button>
                </Form.Item>
              </>
            ) : (
              <Form.Item name={["input", "status"]}>
                <Button
                  type="default"
                  htmlType="submit"
                  onClick={onPublish}
                  size="large"
                  disabled={disabled || false}
                  loading={isSubmitting}
                >
                  <FormattedMessage defaultMessage="Save" />
                </Button>
              </Form.Item>
            )}
          </Space>
        </>
      )}
    </MainCreationForm>
  );
};

export default RecuringEventForm;
